<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->

      <!--Row-->
      <div class="row row-sm">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
          <div class="card">
            <div class="card-body pb-0 border-bottom">
              <div class="d-flex mb-3">
                <h6 class="card-title mb-0">Department</h6>
                <div class="ml-auto d-md-flex">
                  <div class="mr-2">
                    <router-link to="/createdepartment"
                      ><button class="btn btn-primary btn-sm rounded-lg fs-13">
                        <i class="mdi mdi-plus-circle-outline"></i>Create New
                        Department
                      </button></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="table-responsive">
                <table
                  id="example"
                  class="table table-striped"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Company ID</th>
                      <th>Department Name</th>

                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="department in departments" :key="department.id">
                      <td>{{ department.id }}</td>
                      <td>{{ department.companyId }}</td>
                      <td>{{ department.name }}</td>

                      <td>
                        <router-link
                          :to="{
                            name: 'Edit Department',
                            params: { id: department.id },
                          }"
                          ><button class="btn btn-primary">
                            Edit
                          </button></router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- COL END -->
      </div>
    </div>
    <!--Main Content Container-->
  </div>
  <!--Main Content-->
</template>

<script>
//import $ from "jquery";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb,
  },
  props: ["user", "BaseURL"],
  data() {
    return {
      departments: [],
      companyy: [],
    };
  },

  methods: {
    company(id) {
      // var company;
      fetch(this.BaseURL + "/getCompanyById" + id, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          //company = data.name;
          this.companyy.push(data);
        });
      //console.log(company);
      return this.companyy;
    },
  },

  beforeCreate() {
    if (localStorage.getItem("role") !== "Admin") {
      window.location = "/error";
    }
  },

  mounted() {
    fetch(this.BaseURL + "/getAllDepartment", {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.departments = data;
      });
  },
};
</script>